import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_marketing")({
  beforeLoad: async ({ context }) => {
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
    // On an org subdomain the entry point is that org's sign-in: it shows the
    // org's name/description, only sign-in (no sign-up), and the org login form.
    // The generic marketing landing is only for the primary app origin.
    if (context.subdomain) {
      throw redirect({ to: "/sign-in" });
    }
  },
  component: MarketingLayout,
});

function MarketingLayout() {
  return <Outlet />;
}
